import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import sortTags from 'ext:flarum/tags/common/utils/sortTags';
import { dateTime, shortTitle, userLink } from '../utils';

/**
 * Indice dei forum come quello di phpBB: una tabella per categoria (tag padre), una riga per forum (tag figlio)
 * con argomenti, messaggi e ultimo messaggio. Prende il posto della griglia di TagsPage.
 */
export default class BoardIndex extends Component {
  view() {
    const categories = sortTags(this.attrs.tags.filter(tag => tag.position() !== null));
    return m("div", {
      className: "BoardIndex"
    }, categories.map(category => this.category(category)));
  }
  category(category) {
    const forums = sortTags(category.children() || []);
    return m("div", {
      className: "ForumTable"
    }, m("ul", {
      className: "ForumTable-header"
    }, m("li", null, m("dl", null, m("dt", null, m(Link, {
      href: app.route.tag(category)
    }, category.name())), m("dd", {
      className: "ForumTable-count"
    }, "Topics"), m("dd", {
      className: "ForumTable-count"
    }, "Posts"), m("dd", {
      className: "ForumTable-last"
    }, "Last post")))), m("ul", {
      className: "ForumTable-rows"
    }, (forums.length ? forums : [category]).map(forum => this.row(forum))));
  }
  row(forum) {
    const last = forum.lastPostedDiscussion();
    const lastUser = forum.attribute('lastPostedUser');
    return m("li", {
      className: "ForumTable-row"
    }, m("dl", {
      className: "ForumTable-icon ForumTable-icon--forum"
    }, m("dt", null, forum.icon() === 'runeaudio-forum-image' && m("span", {
      className: "ForumTable-image",
      "aria-hidden": "true"
    }), m("div", {
      className: "ForumTable-title"
    }, m(Link, {
      className: "ForumTable-name",
      href: app.route.tag(forum)
    }, forum.name()), forum.description() && m("div", {
      className: "ForumTable-description"
    }, forum.description()))), m("dd", {
      className: "ForumTable-count"
    }, forum.discussionCount(), " ", m("dfn", null, "Topics")), m("dd", {
      className: "ForumTable-count"
    }, forum.attribute('postCount'), " ", m("dfn", null, "Posts")), m("dd", {
      className: "ForumTable-last"
    }, last ? m("span", null, m(Link, {
      href: app.route.discussion(last),
      title: last.title()
    }, shortTitle(last.title())), ' ', m("dfn", null, "Last post"), " by ", lastUser ? userLink({
      id: () => lastUser.id,
      displayName: () => lastUser.username,
      attribute: k => k === 'phpbbColour' ? lastUser.colour : null
    }) : 'Guest', ' ', m(Link, {
      className: "ForumTable-latest",
      href: app.route.discussion(last, last.lastPostNumber()),
      title: "View the latest post"
    }, m("span", {
      className: "sr-only"
    }, "View the latest post")), m("br", null), dateTime(last.lastPostedAt())) : m("span", null, "No posts"))));
  }
}
flarum.reg.add('runeaudio-theme', 'forum/components/BoardIndex', BoardIndex);